"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.compensator = void 0;
const usedWorker = () => !!global.useWorkerCompute;
const wrapValueToArray = (v) => {
    if (Array.isArray(v)) {
        return v;
    }
    return [v];
};
class Compensator {
    constructor() {
        this.handleAddChange = (key, changeData) => {
            if (!usedWorker()) {
                return;
            }
            const { ids, data } = changeData;
            ids.forEach((record) => {
                this[key].set(record, data);
            });
        };
        // private handleDelChange = (key: string, delIds) => {
        //   if (!useWorker) {
        //     return;
        //   }
        //   delIds.forEach((record) => {
        //     this[key].delete(record);
        //   });
        // };
        this.addWillRemoveRecords = (records) => {
            this.handleAddChange('willRemoveRecords', { ids: wrapValueToArray(records), data: true });
        };
        this.checkWillRemoveRecord = (record) => {
            return this.willRemoveRecords.has(record);
        };
        this.setLastGroupInfoIfNull = (groupInfo) => {
            if (!usedWorker()) {
                return;
            }
            if (!this.lastGroupInfo) {
                this.lastGroupInfo = groupInfo;
            }
        };
        this.getLastGroupInfo = () => {
            return this.lastGroupInfo;
        };
        this.clearAll = () => {
            this.willMoveRecords.clear();
            this.willRemoveRecords.clear();
            this.lastGroupInfo = null;
        };
        this.willRemoveRecords = new Map();
        this.willMoveRecords = new Map();
        this.lastGroupInfo = null;
    }
}
exports.compensator = new Compensator();
//# sourceMappingURL=index.js.map